import { cognitoUserInAnyGroup } from '@akin-home/auth/frontend';
import { CognitoUserGroup } from '@akin-home/aws-cognito';
import { useAuthState } from '../../auth-provider/AuthProvider';

interface Props {
  security_groups: CognitoUserGroup[];
  children?: React.ReactNode;
}

/**
 * This component hooks into the currently authenticated user and only renders the children
 * components if the current user is a part of any of the security groups listed in props.
 *
 * It is useful for restricting access to certain parts of an application
 */
export const AllowSecurityGroups = ({ security_groups, children }: Props) => {
  const { auth_user } = useAuthState();

  if (!auth_user || !children) return null;

  if (cognitoUserInAnyGroup(security_groups)(auth_user)) {
    return <>{children}</>;
  }

  return null;
};
